export const DB_ENDPOINTS = {
    MERCHANDISED_PRODUCTS: (networkBrand, collectionKey) => `/v4/${networkBrand}/product/merchandised/${collectionKey}/list`,
    CITRUS_IMPRESSION: (networkBrand, adId) => `/v3/${networkBrand}/citrus-ad/report-impression/${adId}`,
    CITRUS_CLICK: (networkBrand, adId) => `/v3/${networkBrand}/citrus-ad/report-click/${adId}`,
    LOGS: (networkBrand) => `/v4/${networkBrand}/ui/logs`
};
